import * as React from 'react';

import { SegmentLabel } from '@acceligentllc/storybook';

import LockedValue from 'af-components/LockedValue';

import { previewSectionClass, previewSectionClassColumn2, previewSectionClassRow } from '../../helpers';

type Props = {
	requestMBEOrWBERequirementsNote: Nullable<string>;
	requestBondRequirementsNote: Nullable<string>;
	requestHSERequirementsNote: Nullable<string>;
	retainage: Nullable<string>;
	requestInsuranceRequirementsNote: Nullable<string>;
	requestLiquidatedDamagesNote: Nullable<string>;
};

const RequirementsSection: React.FC<Props> = (props) => {
	const {
		requestBondRequirementsNote,
		requestHSERequirementsNote,
		requestInsuranceRequirementsNote,
		requestLiquidatedDamagesNote,
		requestMBEOrWBERequirementsNote,
		retainage,
	} = props;
	return (
		<div className={previewSectionClass}>
			<SegmentLabel
				label="Requirements"
				tooltip="Compliance, financial, and safety requirements that must be met for the successful execution of this job record."
			/>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn2}>
					<LockedValue
						label="MBE/WBE Requirements"
						value={requestMBEOrWBERequirementsNote}
					/>
				</div>
				<div className={previewSectionClassColumn2}>
					<LockedValue
						label="Bond Requirements"
						value={requestBondRequirementsNote}
					/>
				</div>
			</div>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn2}>
					<LockedValue
						label="HSE Requirements"
						value={requestHSERequirementsNote}
					/>
				</div>
				<div className={previewSectionClassColumn2}>
					<LockedValue
						label="Retainage"
						value={retainage}
					/>
				</div>
			</div>
			<div className={previewSectionClassRow}>
				<div className={previewSectionClassColumn2}>
					<LockedValue
						label="Insurance Requirements"
						value={requestInsuranceRequirementsNote}
					/>
				</div>
				<div className={previewSectionClassColumn2}>
					<LockedValue
						label="Liquidated Damages"
						value={requestLiquidatedDamagesNote}
					/>
				</div>
			</div>
		</div>
	);
};

export default React.memo(RequirementsSection);
